import React, { useState, useEffect } from "react";
import classes from './LeftSidePopup.module.css'
import arrowIcon from '../../assests/ContentBank/arrow.png';
import { useSelector } from "react-redux";
import { onKeyDown } from "../../service";

const LeftSidePopup = ({ children, position }) => {
    const direction = useSelector(state => state.translate.direction);
    const [showPopup, setShowPopup] = useState(true)

    useEffect(() => {
        if (window.innerWidth <= 900) {
            setShowPopup(false)
        }
    }, [])

    return (
        <>
            {showPopup && <div className={classes.BackDrop} onClick={()=>{ setShowPopup(false)}}></div>}
            <div style={{ width: showPopup ? '242px' : '32px' }} className={`${classes[direction]} ${classes.PopupContainer}`} >
                {showPopup && <div className={classes.Popup} > <>{children} </></div>}
                <div className={`${classes.ArrowWrapper} ${!showPopup ? classes.ArrowClose : ''}`} onClick={() => setShowPopup(!showPopup)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowPopup(!showPopup))}>
                    <img src={arrowIcon} alt="Arrow" />
                </div>
            </div >
        </>
    )
}

export default LeftSidePopup;